import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { GridPattern } from '../graphics/GridPattern';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
type TrackKey = 'buyer' | 'supplier' | 'desk';
export function HowItWorks() {
  const {
    lang
  } = useLang();
  const t = dictionary.how;
  const [active, setActive] = useState<TrackKey>('buyer');
  const track = t.tracks[active];
  return <section id="how" className="relative py-24 md:py-32 bg-slate-50 overflow-hidden" data-id="element-411">
      <GridPattern className="absolute inset-0 text-navy-deep opacity-[0.04]" data-id="element-412" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8" data-id="element-413">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-414" />

        <div className="mt-12 inline-flex flex-wrap gap-1 p-1 bg-white border border-slate-200 rounded-md" data-id="element-415">
          {(Object.keys(t.tracks) as TrackKey[]).map(key => <button key={key} onClick={() => setActive(key)} className={`relative px-4 md:px-5 h-10 text-sm font-medium rounded-sm transition-colors ${active === key ? 'text-white' : 'text-slate-600 hover:text-navy-deep'}`} data-id="element-416">
              {active === key && <motion.div layoutId="trackTab" className="absolute inset-0 bg-navy-deep rounded-sm" transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-417" />}
              <span className="relative" data-id="element-418">{t.tracks[key].label[lang]}</span>
            </button>)}
        </div>

        <AnimatePresence mode="wait" data-id="element-419">
          <motion.div key={active + lang} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.35
        }} className="mt-10" data-id="element-420">
            <div className="mb-6" data-id="element-421">
              <p className="font-mono text-[11px] tracking-[0.2em] uppercase text-gold-deep" data-id="element-422">
                {track.sublabel[lang]}
              </p>
            </div>

            <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-423">
              {track.steps[lang].map((step, i) => <motion.li key={step} initial={{
              opacity: 0,
              y: 14
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: i * 0.07,
              duration: 0.4
            }} className="relative bg-white border border-slate-200 rounded-md p-6" data-id="element-424">
                  <div className="flex items-center justify-between mb-4" data-id="element-425">
                    <span className="font-mono text-[11px] tracking-wider text-slate-400" data-id="element-426">
                      {t.step[lang]}
                    </span>
                    <span className="font-serif text-3xl text-gold leading-none" data-id="element-427">
                      {String(i + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <p className="text-[14.5px] text-navy-deep leading-snug font-medium" data-id="element-428">
                    {step}
                  </p>
                  {i < track.steps[lang].length - 1 && <span className="hidden lg:block absolute top-1/2 -right-2 w-4 h-px bg-slate-300" data-id="element-429" />}
                </motion.li>)}
            </ol>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}